import { computed, type ComputedRef } from 'vue'

export function useOperationPageFlags(designKey: ComputedRef<string>) {
  const isOrderCenter = computed(() => designKey.value === 'orderCenter')
  const isRefundCenter = computed(() => designKey.value === 'refunds')
  const isComplaintCenter = computed(() => designKey.value === 'complaints')
  const isStoreList = computed(() => designKey.value === 'stores')
  const isStoreCenter = computed(() => isStoreList.value)
  const isProductList = computed(() => designKey.value === 'products')
  const isCategoryCenter = computed(() => designKey.value === 'productCategories')
  const isComboCenter = computed(() => designKey.value === 'productCombos')
  const isExtraCenter = computed(() => designKey.value === 'productExtras')
  const isInventoryCenter = computed(() => designKey.value === 'inventory')
  const isProductCenter = computed(() => isProductList.value || isCategoryCenter.value || isComboCenter.value || isExtraCenter.value || isInventoryCenter.value)
  const isDeliveryRulesCenter = computed(() => designKey.value === 'deliveryRules')
  const isDeliveryMinAmountCenter = computed(() => designKey.value === 'deliveryMinAmount')
  const isDeliveryAreasCenter = computed(() => designKey.value === 'deliveryAreas')
  const isDeliveryPointsCenter = computed(() => designKey.value === 'deliveryPoints')
  const isDeliveryCenter = computed(() => isDeliveryRulesCenter.value || isDeliveryMinAmountCenter.value || isDeliveryAreasCenter.value || isDeliveryPointsCenter.value)
  const isDroneDevicesCenter = computed(() => designKey.value === 'droneDevices')
  const isDroneTasksCenter = computed(() => designKey.value === 'droneTasks')
  const isDroneFlightsCenter = computed(() => designKey.value === 'droneFlights')
  const isDroneFaultsCenter = computed(() => designKey.value === 'droneFaults')
  const isDroneMaintenancesCenter = computed(() => designKey.value === 'droneMaintenances')
  const isDroneCenter = computed(() => isDroneDevicesCenter.value || isDroneTasksCenter.value || isDroneFlightsCenter.value || isDroneFaultsCenter.value || isDroneMaintenancesCenter.value)
  const isUserManagementCenter = computed(() => designKey.value === 'userManagement')
  const isUserBalanceCenter = computed(() => designKey.value === 'userBalance')
  const isUserPointsCenter = computed(() => designKey.value === 'userPoints')
  const isUserAssetsCenter = computed(() => designKey.value === 'userAssets')
  const isUserCenter = computed(() => isUserManagementCenter.value || isUserBalanceCenter.value || isUserPointsCenter.value || isUserAssetsCenter.value)
  const isMemberLevelsCenter = computed(() => designKey.value === 'memberLevels')
  const isGrowthRulesCenter = computed(() => designKey.value === 'memberGrowth')
  const isPointsRulesCenter = computed(() => designKey.value === 'memberPointsRules')
  const isMemberBenefitsCenter = computed(() => designKey.value === 'memberBenefits')
  const isMemberRulesCenter = computed(() => designKey.value === 'memberRules')
  const isMemberCenter = computed(() => isMemberLevelsCenter.value || isGrowthRulesCenter.value || isPointsRulesCenter.value || isMemberBenefitsCenter.value || isMemberRulesCenter.value)
  const isSystemAdminCenter = computed(() => designKey.value === 'systemAdmins')
  const isRoleCenter = computed(() => designKey.value === 'roles')
  const isOperationLogsCenter = computed(() => designKey.value === 'operationLogs')
  const isSystemParamsCenter = computed(() => designKey.value === 'systemParams')
  const isPaymentConfigCenter = computed(() => designKey.value === 'paymentConfig')
  const isSystemCenter = computed(() => isSystemAdminCenter.value || isRoleCenter.value || isOperationLogsCenter.value || isSystemParamsCenter.value || isPaymentConfigCenter.value)
  const isVerificationCenter = computed(() => designKey.value === 'verification')
  const isPrinterCenter = computed(() => designKey.value === 'printers')
  const isMessageLogsCenter = computed(() => designKey.value === 'messageLogs')
  const isMessageTemplatesCenter = computed(() => designKey.value === 'messageTemplates')
  const isMessageConfigCenter = computed(() => designKey.value === 'messageConfig')
  const isMessageCenter = computed(() => isMessageLogsCenter.value || isMessageTemplatesCenter.value || isMessageConfigCenter.value)
  const isDataOverviewCenter = computed(() => designKey.value === 'dataOverview')
  const isDataOrdersCenter = computed(() => designKey.value === 'dataOrders')
  const isDataProductsCenter = computed(() => designKey.value === 'dataProducts')
  const isStoreRankCenter = computed(() => designKey.value === 'storeRankPage')
  const isDataCenter = computed(() => isDataOverviewCenter.value || isDataOrdersCenter.value || isDataProductsCenter.value || isStoreRankCenter.value)
  const isTransactionsCenter = computed(() => designKey.value === 'transactions')
  const isReconciliationCenter = computed(() => designKey.value === 'reconciliation')
  const isRefundTransactionsCenter = computed(() => designKey.value === 'refundTransactions')
  const isProfitSharingCenter = computed(() => designKey.value === 'profitSharing')
  const isProfitSharingRulesCenter = computed(() => designKey.value === 'profitSharingRules')
  const isProfitSharingReceiversCenter = computed(() => designKey.value === 'profitSharingReceivers')
  const isProfitSharingModule = computed(() => isProfitSharingCenter.value || isProfitSharingRulesCenter.value || isProfitSharingReceiversCenter.value)
  const isFinanceCenter = computed(() => isTransactionsCenter.value || isReconciliationCenter.value || isRefundTransactionsCenter.value)
  const isCouponCenter = computed(() => designKey.value === 'marketingCoupons')
  const isPointsMallCenter = computed(() => designKey.value === 'marketingPointsMall')
  const isCardCenter = computed(() => designKey.value === 'marketingCards')
  const isRechargeCenter = computed(() => designKey.value === 'marketingRecharge')
  const isBannerCenter = computed(() => designKey.value === 'marketingBanners')
  const isGroupBuyCenter = computed(() => designKey.value === 'groupBuy')
  const isBargainCenter = computed(() => designKey.value === 'marketingBargain')
  const isInviteCenter = computed(() => designKey.value === 'marketingInvite')
  const isFlashSaleCenter = computed(() => designKey.value === 'flashSale')
  const isMarketingCenter = computed(() => isCouponCenter.value || isCardCenter.value || isRechargeCenter.value || isBannerCenter.value || isGroupBuyCenter.value || isBargainCenter.value || isInviteCenter.value || isFlashSaleCenter.value)
  const isBizPage = computed(() => isOrderCenter.value || isRefundCenter.value || isComplaintCenter.value || isVerificationCenter.value || isPrinterCenter.value || isMessageCenter.value || isStoreCenter.value || isProductCenter.value || isDeliveryCenter.value || isDroneCenter.value || isUserCenter.value || isMemberCenter.value || isPointsMallCenter.value || isMarketingCenter.value || isSystemCenter.value || isDataCenter.value || isFinanceCenter.value || isProfitSharingModule.value)

  return {
    isOrderCenter,
    isRefundCenter,
    isComplaintCenter,
    isStoreList,
    isStoreCenter,
    isProductList,
    isCategoryCenter,
    isComboCenter,
    isExtraCenter,
    isInventoryCenter,
    isProductCenter,
    isDeliveryRulesCenter,
    isDeliveryMinAmountCenter,
    isDeliveryAreasCenter,
    isDeliveryPointsCenter,
    isDeliveryCenter,
    isDroneDevicesCenter,
    isDroneTasksCenter,
    isDroneFlightsCenter,
    isDroneFaultsCenter,
    isDroneMaintenancesCenter,
    isDroneCenter,
    isUserManagementCenter,
    isUserBalanceCenter,
    isUserPointsCenter,
    isUserAssetsCenter,
    isUserCenter,
    isMemberLevelsCenter,
    isGrowthRulesCenter,
    isPointsRulesCenter,
    isMemberBenefitsCenter,
    isMemberRulesCenter,
    isMemberCenter,
    isSystemAdminCenter,
    isRoleCenter,
    isOperationLogsCenter,
    isSystemParamsCenter,
    isPaymentConfigCenter,
    isSystemCenter,
    isVerificationCenter,
    isPrinterCenter,
    isMessageLogsCenter,
    isMessageTemplatesCenter,
    isMessageConfigCenter,
    isMessageCenter,
    isDataOverviewCenter,
    isDataOrdersCenter,
    isDataProductsCenter,
    isStoreRankCenter,
    isDataCenter,
    isTransactionsCenter,
    isReconciliationCenter,
    isRefundTransactionsCenter,
    isProfitSharingCenter,
    isProfitSharingRulesCenter,
    isProfitSharingReceiversCenter,
    isProfitSharingModule,
    isFinanceCenter,
    isCouponCenter,
    isPointsMallCenter,
    isCardCenter,
    isRechargeCenter,
    isBannerCenter,
    isGroupBuyCenter,
    isBargainCenter,
    isInviteCenter,
    isFlashSaleCenter,
    isMarketingCenter,
    isBizPage,
  }
}
